import { MODAL_OPEN, MODAL_CLOSE } from "./types";

export const openModal = () => {
	return {
		type: MODAL_OPEN
	};
};

export const closeModal = () => {
	return {
		type: MODAL_CLOSE
	};
};



// WEBPACK FOOTER //
// ./src/actions/ModalActions.js